module.exports = "https://99designs-start-assets.imgix.net/js/666d31732dba0bf8322becca59a16f9f.jpg";